import { Text } from "@overmap-ai/blocks"
import type { AssetType, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { AssetTypeIcon } from "../../../components/Icons/AssetTypeIcon"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type AssetTypeMentionListProps = MentionListRootProps<Stored<AssetType>>

export const AssetTypeMentionList = memo(
	forwardRef<MentionListRef<Stored<AssetType>>, AssetTypeMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<AssetType>> ref={ref} {...props}>
				{items.map((assetType) => (
					<MentionListItem<Stored<AssetType>> item={assetType} key={assetType.uuid}>
						<AssetTypeIcon assetTypeId={assetType.uuid} inline />
						<Text className="truncate">{assetType.name}</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
AssetTypeMentionList.displayName = "AssetTypeMentionList"
